import { Component, OnInit, ViewChild, Input, Injectable, ElementRef, OnChanges, Output, EventEmitter } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartLegendItem, ChartPluginsOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { CdkDragEnd, CdkDragEnter, CdkDragStart } from "@angular/cdk/drag-drop";
import * as firebase from 'firebase'
import { GraphService } from '../../services/graph.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResizeEvent, ResizableDirective, ResizeHandleDirective } from 'angular-resizable-element';
import { OverlayModule } from '@angular/cdk/overlay';
import xml2js from 'xml2js';
import { PrestashopService } from '../../services/prestashop.service';
import { AnalyticsService} from '../../services/analytics.service';
import { AuthService } from '../../services/auth.service';
import 'chartjs-plugin-labels';
import { rgba } from 'ng-chartjs';
import { DateService } from '../../services/date.service'
import * as Chart from "chart.js";
import * as ChartGeo from "chartjs-chart-geo";
import { JWT, GoogleAuth } from 'google-auth-library'
import { resolve } from 'dns';
import { sign } from 'crypto';
import * as angular from "angular";
const keys = require('../jsdashboard-719092c7aa96.json')
var forge = require('node-forge');
var jwt = require('jsonwebtoken');
import { KJUR, KEYUTIL } from 'jsrsasign'
import { InvokeFunctionExpr } from '@angular/compiler';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input('graph') graph
  @Input('setting') setting
  @Input('isText') isText = false
  @Input('date_start') date_start
  @Input('date_end') date_end
  @Input('newDate') newDate = true
  @Input('page') page
  @Input('compteur') compteur
  @Input('realtime') realTime
  @Input('shopId') shopId

  constructor(private graphService: GraphService,
    private _http: HttpClient,
    private prestashopService: PrestashopService,
    private authService: AuthService,
    private dateService: DateService,
    private analyticsService: AnalyticsService) {

  }
  lineChartData: ChartDataSets[] = [
    {
      data: [],
      label: ''
    }
  ];

  lineChartLabels: Label[] = [];

  lineChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
      labels: {

      },
      onClick: (e, legendItem) => {
        var index = legendItem.datasetIndex;
        if (index == undefined) {
          index = legendItem.index
        }
        var ci = this.chart.chart;
        var type = this.lineChartType
        var meta
        if (type == "pie") {
          meta = ci.getDatasetMeta(0).data[index];
          if (meta.hidden === false) {
            var str = ci.config.data.datasets[0].backgroundColor[index]

            var mySubString = str.substring(
              str.lastIndexOf(",") + 1,
              str.lastIndexOf(")")
            );

            ci.config.data.datasets[0].backgroundColor[index] = str.replace(mySubString, '0.1')
            meta.hidden = true
          } else {

            meta.hidden = false
            var str = ci.config.data.datasets[0].backgroundColor[index]
            ci.config.data.datasets[0].backgroundColor[index] = str.replace('0.1', '0.7')
          }
        }
        else {
          meta = ci.getDatasetMeta(index);

          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
        }
        ci.update();
        type == "pie" ? this.showData[0].value = ci.getDatasetMeta(0).total : "";
      },
    },
    plugins: {
      labels: {
        fontColor: '#000',
        position: 'outside',
        fontSize: 14,
        fontStyle: 'bold',
        textMargin: 10
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItems, data) => {
          return (this.lineChartType == 'pie' ? data.datasets[0].data[tooltipItems.index] + ' ' + tooltipItems.yLabel + this.unite : data.datasets[0].data[tooltipItems.index] + ': ' + tooltipItems.yLabel + this.unite)

        }
      }
    },
  };
  red = 'rgb(255, 99, 132)'
  lineChartColors: Color[] = [
    {
      borderColor: '',
      backgroundColor: 'rgba(255,255,0,0.28)',
    },
  ];

  colorSave = []
  lineChartLegend = true;
  lineChartType = 'line';
  draggable = false
  height: any
  width: any
  top: any
  left: any
  myValue: number
  user: any
  ref: any
  isSet = false
  isActive: boolean
  minHeight
  minWidth
  resize = true
  load = false
  unite: string = "€"
  set = true
  oldCompt:number=0;
  initialPosition: any
  position = { ...this.initialPosition };
  offset = { x: 0, y: 0 };
  type
  api
  jsonData
  showData = []
  numTitle
  oldStartDate
  oldEndDate
  gotData = false
  source
  dimensions
  filter
  errormsg
  place:boolean
  @Output() uploaded = new EventEmitter<boolean>();
  oldData;
  newData;
  firstsound = true
  lastShopId
  ngOnInit(): void {

  }

  uploadComplete() {
    this.uploaded.emit(true);
  }
  ngOnChanges() {
    this.realTime = localStorage.getItem('realTime')
    this.user = firebase.auth().currentUser.uid
    this.shopId = localStorage.getItem('shopId');
    this.authService.getService().then(() => {
      if (this.page == 'Service') {
        this.ref = firebase.database().ref('PageConfig/' + this.page + '/' + localStorage.getItem('admin_service') + '/Charts/' + this.graph)
      }
      if (this.page == 'Home') {
        this.ref = firebase.database().ref('PageConfig/' + this.page + '/Charts/' + this.graph)
      }
      if (this.page == 'Profil') {
        this.ref = firebase.database().ref('PageConfig/' + this.page + '/' + this.user + '/Charts/' + this.graph)
      }
    }).then(() => {
      if (this.isSet == false) {
        this.generate()
      } if (this.oldStartDate != this.date_start || this.oldEndDate != this.date_end) {
        this.getDataFromApi();
        this.set = true
      }
      if(this.realTime == '1'){
        this.getDataFromApi();
        this.set = true
        this.oldCompt = this.compteur;
      }
      if(this.lastShopId !=  localStorage.getItem('shopId')){
        this.getDataFromApi();
        this.set = true
      }
      this.lastShopId = localStorage.getItem('shopId');
      this.oldEndDate = this.date_end
      this.oldStartDate = this.date_start
      this.uploadComplete()
    })



  }
  //Fonction enregistrant la taille et la position après un Drag&Drop
  dragEnd(event: CdkDragEnd) {
    if(this.place == true){
      this.offset = { ...(<any>event.source._dragRef)._passiveTransform };
      this.position.x = this.initialPosition.x + this.offset.x;
      this.position.y = this.initialPosition.y + this.offset.y;
      if (this.type == 'graph') {
        this.ref.update({
          width: this.chart.chart.canvas.parentElement.style.width.replace('px', ''),
          height: this.chart.chart.canvas.parentElement.style.height.replace('px', ''),
          top: this.top + this.offset.y,
          left: this.left + this.offset.x
        })
      } else {
        this.ref.update({
          width: this.width,
          height: this.height,
          top: this.top + this.offset.y,
          left: this.left + this.offset.x
        })
      }
    } 
  }

  dragStart(event: CdkDragStart) {
    this.place = true;
  }

  //Fonction pour désactiver un bloc graph
  setInactive(comp) {
    if (this.load != true) {
      this.load = true
      this.graphService.setInactive(comp, this.page).then(() => {


      })

    }

  }

  //Fonction pour changer le style d'un graph (line, bar, pie, etc...)
  changeStyle(style: string) {
    this.graphService.changeType(this.graph, style);
    this.lineChartType = style
  }

  //Fonction pour modifier la taille d'un bloc graph
  onResizeEnd(event: ResizeEvent): void {


    if (this.type == 'graph') {
      var height = parseInt(this.chart.chart.canvas.style.height, 10)
      if (height + 10 == event.rectangle.height) {
        this.chart.chart.canvas.parentElement.style.width = event.rectangle.width + 'px'
        this.chart.chart.canvas.parentElement.style.height = (height + 10) + 'px'
      } else {
        this.chart.chart.canvas.parentElement.style.width = (event.rectangle.height * 2) + 'px'
        this.chart.chart.canvas.parentElement.style.height = (event.rectangle.heigh + 10) + 'px'
      }
    }
    else {
      this.width = (event.rectangle.height * 2)
      this.height = (event.rectangle.height + 10)

    }


    if (this.type == "graph") {
      this.ref.update({
        width: this.chart.chart.canvas.parentElement.style.width.replace('px', ''),
        height: this.chart.chart.canvas.parentElement.style.height.replace('px', ''),
        top: this.top + this.offset.y,
        left: this.left + this.offset.x
      })
      this.chart.chart.resize()
      var height = parseInt(this.chart.chart.canvas.style.height, 10)
      this.chart.chart.canvas.parentElement.style.height = (height + 10) + 'px'
    }
    else {
      this.ref.update({
        width: this.width,
        height: this.height,
        top: this.top + this.offset.y,
        left: this.left + this.offset.x
      })
    }

  }

  intoDrag(e) {
    this.resize = false
  }
  outDrag(e) {
    this.resize = true
  }

  generate() {
    firebase.database().ref('PageConfig/Home/Charts/' + this.graph + '/config').orderByKey().once("value", (snapshot) => {
      this.type = snapshot.val().type;
      this.api = snapshot.val().api;
      this.numTitle = snapshot.val().Titre
      this.source = snapshot.val().source
      if(snapshot.val().multi == true)
        this.shopId = localStorage.getItem('shopId');
      else
        this.shopId = '0';
      if (snapshot.val().source == "GA") {
        this.dimensions = snapshot.val().dimension
        this.filter = snapshot.val().filter
      }
    }).then(() => {
      this.ref.orderByKey().once("value", (snapshot) => {
        this.initialPosition = { x: snapshot.val().left, y: snapshot.val().top }
        this.minWidth = 320
        this.minHeight = 180
        this.height = snapshot.val().height
        this.width = snapshot.val().width
        if (this.graphService.setPosY() != null && this.graphService.setPosX() != null){
          this.top = this.graphService.setPosY()
          this.left = this.graphService.setPosX()
        }else{
          this.top = snapshot.val().top
          this.left = snapshot.val().left
        }       
        this.isActive = snapshot.val().actif
        this.lineChartType = (this.type != "number" ? snapshot.val().type : 'pie')
        this.lineChartOptions.plugins.labels.fontColor = (this.type != "number" ? 'transparent' : 'black')
        this.unite = (snapshot.val().unit != undefined ? snapshot.val().unit : " ")
      }).then(() => {
        this.getDataFromApi()
      }).then(() => {
        this.isSet = true
      })
    })

  }

  getDataFromApi() {
    if (this.api != undefined) {
      switch (this.source) {
        case 'presta':
          this.prestashopService.getData(this.api, this.date_start, this.date_end, this.shopId).subscribe((response) => {
            if (this.type != "graph" && angular.equals(this.oldData, response) ==false) {
              this.lineChartData = []
              this.lineChartColors = []
              this.lineChartLabels = []
              var array = Object.keys(response)
                this.showData = []
                array.forEach(element => {
                  Object.keys(response[element]).forEach((key) => {
                    var title = key.charAt(0).toUpperCase() + key.slice(1)
                    this.showData.push({ key: title, value: parseFloat(response[element][key]) })
                  })
                });  
              var tab = []
              var color = []
              var col
              this.showData.forEach((key) => {
                if (key.key != 'Total' && key.value > 0) {
                  tab.push(key.value)
                  switch (key.key) {
                    case 'Dxf':
                      col = 'rgb(125, 185, 232, 0.7)'
                      break;
                    case 'Edit':
                      col = 'rgb(232, 60, 105, 0.7)'
                      break
                    case 'Mixte':
                      col = 'rgb(200, 200, 200, 0.7)'
                      break
                    case 'Bois':
                      col = 'rgb(255, 180, 0, 0.7)'
                      break
                    case 'Metal':
                      col = 'rgb(52, 58, 64, 0.7)'
                      break
                    case 'J3':
                      col = 'rgb(232, 60, 105, 0.7)'
                      break
                    case 'J5':
                      col = 'rgb(253, 126, 20, 0.7)'
                      break
                    case 'J15':
                      col = 'rgb(255, 180, 0, 0.7)'
                      break
                    default:
                      col = this.random_rgba()
                      break;
                  }
                  color.push(col)
                  this.lineChartLabels.push(key.key)
                  this.gotData = true

                }

              })
              this.colorSave.push(color)
              this.lineChartData.push({ label: 'first', data: tab, backgroundColor: color, borderColor: color })
              if(this.numTitle == "Total de commandes" && this.realTime == "1"){
                if(this.firstsound == false){
                  this.playAudio();
                }
                else{
                  this.firstsound = false;
                }
                
              }else{
                this.firstsound = true;
              }
            }
            else {
              if(angular.equals(this.oldData, response) ==false){
                var array = Object.keys(response)
                var tab = []
                var scntab = []
                var count = 0
                this.lineChartLabels = []
                array.forEach(element => {
                  this.lineChartLabels.push(element)
                  Object.keys(response[element]).forEach((key) => {
                    var title = key.charAt(0).toUpperCase() + key.slice(1)
                    if (tab[title] == undefined) {
                      tab[title] = []
                    }
                    tab[title].push(parseFloat(response[element][key]))
                  })
                });
                this.lineChartData = []
                Object.keys(tab).forEach((key) => {
                  this.lineChartData.push({ label: key, data: tab[key] })
                })
              }
            }
            this.oldData = response;
          })
          break;
        case 'GA':
          this.loadScript('https://apis.google.com/js/client:platform.js');
          setTimeout(() => {
            this.queryReports()
          }, 500);
          break
        default:
          break;
      }


    }
  }

  random_rgba() {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',0.7)';
  }

  queryReports() {
    if (this.set == true) {
      this.set = false
      var VIEW_ID = this.analyticsService.getViewId();
      var tab = []
      var color = []
      var test: number = 0

      var request = {
        path: 'https://analyticsreporting.googleapis.com//v4/reports:batchGet',
        method: 'POST',
        body: {
          reportRequests: [
            {
              viewId: VIEW_ID,
              filtersExpression: this.filter,
              dateRanges: [
                {
                  startDate: this.date_start,
                  endDate: this.date_end
                }
              ],
              metrics: [
                {
                  expression: this.api
                }
              ],
            }
          ]
        }
      }
      var dimension =
      {
        name: this.dimensions
      }
      if (this.dimensions != '') {
        request.body.reportRequests[0]['dimensions'] = dimension
      }

      var now = Math.floor(Date.now() / 1000)
      // Header
      var oHeader = { alg: 'RS256', typ: 'JWT' };
      // Payload
      var oPayload = {
        "iss": "admin-625@jsdashboard.iam.gserviceaccount.com",
        "scope": "https://www.googleapis.com/auth/analytics.readonly",
        "aud": "https://oauth2.googleapis.com/token",
        "exp": now + 3600,
        "iat": now
      };
      var sHeader = JSON.stringify(oHeader);
      var sPayload = JSON.stringify(oPayload);
      var sJWT = KJUR.jws.JWS.sign("RS256", sHeader, sPayload, keys.private_key);
      const optionRequete = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      };
      this._http.post('https://oauth2.googleapis.com/token', 'grant_type=urn%3Aietf%3Aparams%3Aoauth%3Agrant-type%3Ajwt-bearer&assertion=' + sJWT, optionRequete).subscribe((response) => {
        gapi.client.init({
          apiKey: this.analyticsService.getApiKey(),
          discoveryDocs: ['https://analyticsreporting.googleapis.com/$discovery/rest?version=v4']
        }).then(() => {
          gapi.client.setToken({ access_token: response['access_token'] })
          gapi.client.request(request).then((result) => {
            if(angular.equals(this.oldData, result.result.reports[0]) ==false){
              this.showData = []
              this.lineChartData = []
              this.lineChartColors = []
              this.lineChartLabels = []
              this.showData.push({ key: 'Total', value: result.result.reports[0].data.totals[0].values[0] })
              result.result.reports[0].data.rows.forEach(element => {
                if (element.dimensions) {
                  var key = element.dimensions[0]
                  var val = element.metrics[0].values[0]
                  this.lineChartLabels.push(key)
                  tab.push(val)
                  var col = this.random_rgba()
                  color.push(col)
                  this.showData.push({ key: key, value: parseFloat(val) })
                }
              });
              this.newData = true;
            }
            this.oldData = result.result.reports[0];
          }, (error) => {
            this.errormsg = "Connectez votre compte Google John Steel à votre navigateur"
          }).then(() => {
            if(this.newData == true){
              this.colorSave.push(color)
              this.lineChartData.push({ label: 'first', data: tab, backgroundColor: color, borderColor: color })
              this.lineChartData.length = 1
              this.gotData = this.showData.length == 1 ? false : true;
              this.newData = false;
            }
          }).then(() => {
            if (this.type == 'map') {
              this.generateMap()
            }
          })
        })
      })

    }

  }
  async loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = false;
    body.appendChild(script);
  }

  generateMap() {
    fetch(
      "https://raw.githubusercontent.com/deldersveld/topojson/master/continents/europe.json"
    )
      .then(r => r.json())
      .then(br => {

        var geoData = ChartGeo.topojson.feature(br, br.objects.continent_Europe_subunits).features;
        for (let i in geoData) {
          for (let k in this.lineChartLabels) {
            this.lineChartLabels[k] = (this.lineChartLabels[k] == 'United Kingdom' ? 'England' : this.lineChartLabels[k])
            this.lineChartLabels[k] = (this.lineChartLabels[k] == 'Czechia' ? 'CzechRepublic' : this.lineChartLabels[k])
            this.lineChartLabels[k] = (this.lineChartLabels[k] == 'North Macedonia' ? 'Macedonia' : this.lineChartLabels[k])
            this.lineChartLabels[k] = (this.lineChartLabels[k] == 'Bosnia & Herzegovina' ? 'BosniaandHerzegovina' : this.lineChartLabels[k])
            if (geoData[i].properties.geounit == this.lineChartLabels[k]) {
              geoData[i].properties.confirmed = Number(this.lineChartData[0].data[k]);
            }
          }
        }
        let dts = {
          labels: geoData.map(i => i.properties.geounit),
          datasets: [
            {
              outline: geoData,
              data: geoData.map(i => ({
                feature: i,
                value: i.properties.confirmed
              }))
            }
          ]
        };

        let configOptions = {
          maintainAspectRatio: true,
          responsive: true,
          showOutline: true,
          showGraticule: true,
          legend: {
            display: false
          },
          scale: {
            projection: "equalEarth"
          } as any,
          geo: {
            colorScale: {
              display: true,
              interpolate: "YlOrRd",
              missing: "white",
              legend: {
                display: "true",
                position: "bottom-right"
              }
            }
          }
        };
        var ctx = <HTMLCanvasElement>document.getElementById("confirmedGeoCanvas")
        new Chart(
          <HTMLCanvasElement>document.getElementById("confirmedGeoCanvas"),
          {
            type: "choropleth",
            data: dts,
            options: configOptions
          }
        );
      });
  }

  toUTF8Array(str) {
    let utf8 = [];
    for (let i = 0; i < str.length; i++) {
      let charcode = str.charCodeAt(i);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6),
          0x80 | (charcode & 0x3f));
      }
      else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + (((charcode & 0x3ff) << 10)
          | (str.charCodeAt(i) & 0x3ff));
        utf8.push(0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
    }
    return utf8;
  }

  playAudio(){
    let audio = new Audio();
    audio.src = this.graphService.getAudioUrl();
    audio.load();
    audio.play();
  }
}
